export default __webpack_public_path__ + "static/media/getbannerbottom1.83bc92bb63308209064b8025fa018f19.svg";